module.exports = __webpack_public_path__ + "img/logo-company-full-horizontal.af393f68.svg";